export const HAKLAI_ANALYSIS_RESULTS_LABELS = Object.freeze({
  residential: "בית מגורים",
  commercial: "נכס מסחרי",
  landAndShared: "קרקע ומשותף",
  farmRemainder: "יתרת המשק",
  propertyType: "סוג הנכס",
  nominalAcquisitionPrice: "מחיר רכישה נומינלי",
  indexedAcquisitionPrice: "מחיר רכישה ממודד",
  saleValue: "שווי מכירה",
  indexedExpenses: "הוצאות ממודד",
  depreciation: "פחת",
  payableTax: "לתשלום",
  genericAsset: "נכס",
  singleApartmentExemption: "פטור דירה יחידה",
  inheritanceExemption: "פטור ירושה",
  totalShevach: "סה״כ שבח בעסקה",
  capitalGainsTax: "סה״כ מס שבח",
  totalTaxToPay: "סה״כ מס לתשלום",
  businessLossOffset: "קיזוז עסקי",
  capitalLossOffset: "קיזוז הוני",
  rabinovichDiscount: "הנחת רבינוביץ",
  prisaYears: "שנות פריסה",
  prisaSavings: "חיסכון פריסה",
  prisaTaxAfterPrisa: "סה״כ מס שבח לאחר פריסה",
  afkaaCredit: "זיכוי הפקעה",
  resultsTitle: "תוצאות חישוב",
  backToCalc: "חזרה לחישוב",
  calcDetails: "פירוט חישוב",
  summary: "סיכום"
});

export const HAKLAI_ANALYSIS_RESULTS_MESSAGES = Object.freeze({
  noResults: "עדיין אין תוצאות להצגה. יש לחזור למסך החישוב וללחוץ על נתח.",
  inconsistentResults:
    "התוצאות השמורות אינן תואמות לסיכום העסקה. יש לחזור למסך החישוב ולהריץ ניתוח מחדש."
});
